import gsap from "gsap"

document.addEventListener('DOMContentLoaded', () => {

    const galleries = document.querySelectorAll('.infinite-scroll')

    if (galleries) {
        galleries.forEach(item => {
            const galleryContainer = item.querySelector('.gallery-section')
            const rect = galleryContainer.getBoundingClientRect()

            if (galleryContainer) {
                const clone = galleryContainer.cloneNode(true)
                item.appendChild(clone)
            }

            item.style.width = `${rect.width * 2}px`


            setTimeout(() => {
                gsap.to(item, {
                    x: rect.width * -1,
                    ease: 'none',
                    duration: innerWidth < 700 ? 30 : 40,
                    repeat: -1
                })
            }, 100)

        })
    }

})